<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: ['values', 'labels'],
  data () {
    return {
      data: {
        labels: this.labels, // xlabels
        datasets: [{
          label: 'Number of Interventions',
          data: this.values, // values
          backgroundColor: ['#FF6384', '#FFCD56', '#36A2EB']
        }]
      },
      options: {
        responsive: true
      }
    }
  },
  mounted () {
    this.renderChart(this.data, this.options)
  }
}
</script>
